const OPERATIONAL_IGNORED_BUILD_PATTERNS = [
  "claude-plugins",
  "Claude Code",
  "eterno/Publish Storybook",
  "eterno/Deploy Preview Environment",
  "eterno/Destroy Preview Environment",
  "eterno/Release Eterno CLI",
  "eterno/Service Reservation Generated Configs",
  "lambda-removebg/Check Parse Credit Module SKUs",
  "terraform-kms/Check KMS key status",
  "backup/Export DynamoDB Tables to S3",
];

function getProjectName(build) {
  return build?.projectName || "";
}

export function shouldIgnoreOperationalBuild(build) {
  const projectName = getProjectName(build).toLowerCase();
  if (!projectName) return false;

  return OPERATIONAL_IGNORED_BUILD_PATTERNS.some((pattern) =>
    projectName.includes(pattern.toLowerCase())
  );
}

export function isEternoDeployBuild(build) {
  const projectName = getProjectName(build).toLowerCase();
  if (!projectName) return false;

  return (
    build.provider === "github_actions" &&
    build.repositoryName === "eterno" &&
    (
      projectName.startsWith("eterno/deploy prod ") ||
      projectName.startsWith("eterno/deploy dev ")
    ) &&
    !projectName.includes("preview")
  );
}

export function getEternoDeployEnvironment(build) {
  const projectName = getProjectName(build).toLowerCase();

  if (projectName.includes("deploy prod") || projectName.includes("-prod")) {
    return "prod";
  }

  return "dev";
}

function getGitHubRunId(build) {
  const runId = build?.providerData?.runId;
  return runId == null ? null : String(runId);
}

function getGitHubRunAttempt(build) {
  const runAttempt = Number(build?.providerData?.runAttempt);
  return Number.isFinite(runAttempt) ? runAttempt : 0;
}

function isFinalBuildStatus(status) {
  return status !== "in_progress";
}

function getDeploySortDate(build) {
  return new Date(build?.completedAt || build?.startedAt || 0).getTime();
}

function shouldReplaceDeployBuild(current, candidate) {
  const currentAttempt = getGitHubRunAttempt(current);
  const candidateAttempt = getGitHubRunAttempt(candidate);

  if (candidateAttempt !== currentAttempt) {
    return candidateAttempt > currentAttempt;
  }

  const currentFinal = isFinalBuildStatus(current.status);
  const candidateFinal = isFinalBuildStatus(candidate.status);
  if (candidateFinal !== currentFinal) {
    return candidateFinal;
  }

  return getDeploySortDate(candidate) >= getDeploySortDate(current);
}

export function dedupeEternoDeployBuilds(builds) {
  const keyedBuilds = new Map();
  const unkeyedBuilds = [];

  for (const build of builds) {
    const runId = getGitHubRunId(build);
    if (!runId) {
      unkeyedBuilds.push(build);
      continue;
    }

    const key = `${build.repositoryName || "eterno"}:${runId}`;
    const current = keyedBuilds.get(key);
    if (!current || shouldReplaceDeployBuild(current, build)) {
      keyedBuilds.set(key, build);
    }
  }

  return [...keyedBuilds.values(), ...unkeyedBuilds].sort(
    (a, b) => getDeploySortDate(b) - getDeploySortDate(a)
  );
}
